import * as Buttons from './Variants';

export default Buttons;
